var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M10.256 4.131a.875.875 0 0 1 1.238 0l5.25 5.25a.875.875 0 0 1 0 1.238l-5.25 5.25a.875.875 0 1 1-1.238-1.238l3.757-3.756H3.875a.875.875 0 0 1 0-1.75h10.138l-3.757-3.756a.875.875 0 0 1 0-1.238",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;